
export class sliderModel
{
  sliders:[];
  result:number;
  message:[];

}

export class slider
{

   language:string = 'tr';
   a_target: string;
   content: string;
   content_type: string;
   create_date: string;
   external_link: string;
   image_url: string;
   is_popup: string;
   sli_uid: string;
   title: string;
   update_date: string;
   sort:string;

}